 import {getStockLogList} from "@/api/Stock"

 export default {
   fetchDataListItemsStockLog({
     commit
   }, payload) {
     return new Promise((resolve, reject) => {
      getStockLogList(payload)
         .then((response) => {
           if (response.status === 200) {
             commit('SET_STOCK_LOG', response.data);
             resolve(response);
           } else {
             reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
           }
         })
         .catch(error => {
           reject(new Error("Sunucu Bağlantısı Başarısız !"));
         })
     })
   },
 };